document.addEventListener('DOMContentLoaded', () => {

  // Generic - Toggle all details elements to open before printing
  window.addEventListener("beforeprint", () => {
    document.querySelectorAll("details").forEach((detail) => {
      detail.setAttribute("open", "true");
    });
  });

  window.addEventListener("afterprint", () => {
    document.querySelectorAll("details").forEach((detail) => {
      detail.removeAttribute("open");
    });
  });

  // Specific - Print button
  const printButton = document.querySelector('.page-utilities__print-button');

  if (printButton) {
    printButton.addEventListener('click', () => {
      window.print();
    });
  }
});